// extracted by mini-css-extract-plugin
export default {"priceNote":"UpdateInflatedPriceModal_priceNote__-ahyK","price":"UpdateInflatedPriceModal_price__Sr2uw"};